import { consoleLogger } from '@shared/logging/consoleLogger';
import { APIMethods, getErrorMessage } from '@shared/api/utiqAPIMethods';
import { APIMethodsType, APIMethodNameType } from '@utiqLoader/types';

export const initializeUtiqAPI = () => {
  const handler = {
    get(API: APIMethodsType, methodName: APIMethodNameType) {
      // Verify if the function exists
      if (methodName in API) {
        return API[methodName];
      } else {
        // Return default behavior function
        return () => {
          if (methodName in APIMethods) {
            consoleLogger.logWarn(getErrorMessage(methodName));
          } else if ((methodName as string) === 'toJSON') {
            return () => '"Utiq.API"';
          } else {
            consoleLogger.logError(
              `Method "${methodName}" does not exist in Utiq API.`,
            );
          }
        };
      }
    },
  };
  window.Utiq ||= {};
  window.Utiq.API = new Proxy(window.Utiq.API || {}, handler);
};
